import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkMembershipPermissions } from "../../../redux/permissions/UserPermissions";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import PrivateHeader from "../../Layouts/PrivateRouteLayouts/PrivateHeader";
import PrivateFooter from "../../Layouts/PrivateRouteLayouts/PrivateFooter";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("urexperttoken");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");

  const role_type = localStorage.getItem("role_type");

  const checkPermissions = async (posttype) => {
    try {
      const response = await dispatch(checkMembershipPermissions(posttype));

      if (!response?.status) {
        navigate(`${lan}/account`);
        urtoast("You Need Permissions, Please Take Membership Plane", 2);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //
  //   switch (location.pathname) {
  //     case '/account/updateproject/:id':
  //       checkPermissions('publish_project')
  //       break;
  //     case '/account/updatecontest/100':
  //       checkPermissions('create_contest')
  //       break;
  //     case '/account/updatejob/100':
  //       checkPermissions('posting_jobs')
  //       break;
  //     // case '/account/postbxp':
  //     //   checkPermissions('posting_jobs')
  //     //   break;
  //     default:
  //       break;
  //   }
  // }, [location]);
  if (token) {
    if (location.pathname == `/${lan}/registration` || location.pathname == `/${lan}/registrationsuccessful`) {
      if (role_type == 2) {
      }
      else {
        navigate(`/${lan}/account`)
      }
    }
    return (
      <>
        <PrivateHeader />
        {children}
        {location.pathname == `/${lan}/account/chats` ? "" : <PrivateFooter />}

        {/* <PrivateFooter /> */}
      </>
    );
  }


  return <Navigate to={`/${lan}/loginwithemail`} />;
};

export default PrivateRoute;
